// extracted by mini-css-extract-plugin
export default {"title":"balance_title__Wbqk6","logo":"balance_logo__zV9Zk","balance":"balance_balance__KBd30","amount":"balance_amount__tR+Y2","solCoin":"balance_solCoin__HvWWG"};